import { defineStore } from 'pinia';
import { MessengerMode } from '@/types/Messenger';
import ParentService from '../services/parent.service';
import { mergeLocaleMessages } from "@/utils/lang.util";
import dayjs from 'dayjs';
import 'dayjs/locale/nl';
import 'dayjs/locale/ar';
import 'dayjs/locale/es';
import 'dayjs/locale/pt';
import 'dayjs/locale/he';
import 'dayjs/locale/id';
export var MessengerTheme;
(function (MessengerTheme) {
    MessengerTheme["LIGHT"] = "light";
    MessengerTheme["DARK"] = "dark";
})(MessengerTheme || (MessengerTheme = {}));
export var MessengerFrameSize;
(function (MessengerFrameSize) {
    MessengerFrameSize["NORMAL"] = "normal";
    MessengerFrameSize["EXPANDED"] = "expanded";
})(MessengerFrameSize || (MessengerFrameSize = {}));
const locales = {
    en: () => import('dayjs/locale/en'),
    nl: () => import('dayjs/locale/nl'),
    ar: () => import('dayjs/locale/ar'),
    es: () => import('dayjs/locale/es'),
    pt: () => import('dayjs/locale/pt'),
    he: () => import('dayjs/locale/he'),
    id: () => import('dayjs/locale/id'),
    de: () => import('dayjs/locale/de'),
};
export const useConfigStore = defineStore('config', {
    state: () => {
        return {
            brandingEnabled: true,
            switchThemeEnabled: true,
            locale: 'en',
            mode: MessengerMode.NORMAL,
            theme: MessengerTheme.LIGHT,
            browserName: null,
            frameSize: MessengerFrameSize.NORMAL,
            frameVisibility: false,
            frameOpenedOnce: false,
            fullScreenMode: false,
            settings: {},
        };
    },
    getters: {
        currentLocale: (state) => state.locale,
        currentMode: (state) => state.mode,
        currentTheme: (state) => state.theme,
        browser: (state) => state.browserName,
        isBrandingEnabled: (state) => state.brandingEnabled,
        isFrameOpenedOnce: (state) => state.frameVisibility,
        isFrameVisible: (state) => state.frameOpenedOnce,
        isFullScreenMode: (state) => state.fullScreenMode,
        isNormalFrameSize: (state) => state.frameSize === MessengerFrameSize.NORMAL,
        isPageSelectorFooterEnabled: (state) => state.settings['appearance']?.showPageSelectorFooter,
        isLanguageSelectorEnabled: (state) => state.settings['appearance']?.showLanguageSelector,
        isSwitchThemeEnabled: (state) => state.switchThemeEnabled,
        isWideFrameSize: (state) => state.frameSize === MessengerFrameSize.EXPANDED,
        isPrechatEnabled: (state) => state.settings['conversation']?.prechatEnabled,
        currentSettings: (state) => state.settings,
        logoImageUrl: (state) => state.settings['appearance']?.logoImageUrl,
    },
    // could also be defined as
    actions: {
        // approveGDPR(b) {
        //     this.GdprApproved = b
        //     ParentService.approveGDPR(b)
        // },
        setBrowser(b) {
            this.browserName = b;
        },
        updateSettings(settings) {
            // override locale values (need to be changed on BE imho)
            settings.locales.forEach((locale, idx) => {
                switch (locale) {
                    case 'ENGLISH':
                        settings.locales[idx] = 'en';
                        break;
                    case 'SPANISH':
                        settings.locales[idx] = 'es';
                        break;
                    case 'PORTUGUESE':
                        settings.locales[idx] = 'pt';
                        break;
                    case 'DUTCH':
                        settings.locales[idx] = 'nl';
                        break;
                    case 'ARABIC':
                        settings.locales[idx] = 'العربية';
                        break;
                    case 'HEBREW':
                        settings.locales[idx] = 'עִברִית';
                        break;
                    case 'INDONESIAN':
                        settings.locales[idx] = 'id';
                        break;
                    case 'GERMAN':
                        settings.locales[idx] = 'de';
                        break;
                }
            });
            this.settings = settings;
        },
        mergeLocaleMessages(newMsgs, mergeFields) {
            mergeLocaleMessages(newMsgs, mergeFields);
        },
        setLocale(locale) {
            // convert arabic/hebrew text into language code 2
            if (locale === 'العربية') {
                locale = 'ar';
            }
            else if (locale === 'עִברִית') {
                locale = 'he';
            }
            this.locale = locale;
            // dynamic locale dynamically
            locales[locale]().then(() => {
                dayjs.locale(locale);
                ParentService.changeLocale(locale);
            });
        },
        setFullScreenMode(enabled) {
            this.fullScreenMode = enabled;
        },
        setMessengerMode(mode) {
            ParentService.setMessengerMode(mode);
            this.mode = mode;
        },
        setTheme(theme) {
            this.theme = theme;
            ParentService.changeTheme(this.theme);
            // set dom
            document.documentElement.className = this.theme + '-theme';
        },
        // setRtl(b:boolean) {
        //
        // },
        setBrandingEnabled(bool) {
            this.brandingEnabled = bool;
        },
        setSwitchThemeEnabled(bool) {
            this.switchThemeEnabled = bool;
        },
        setHideResolvedConversations(bool) {
            this.hideResolvedConversations = bool;
        },
        setFrameVisibility(bool) {
            this.frameVisibility = bool;
            // // restore last view opened only for the first time
            if (bool && !this.frameOpenedOnce) {
                this.frameOpenedOnce = true;
                const settings = ParentService.getPersistedSettings();
                if (settings.messenger.currentView) {
                    // push the home view first but without changing the view so it acts only as
                    // an entry so the user can press back arrow to go to the home view.
                    // if(settings.messenger.currentView.name !== Views.PAGE) {
                    // do not push itself
                    // console.log('here');
                    // CoreService.push(Views.PAGE, {id: 'home'}, true)
                    // }
                    // console.log('here2');
                    // CoreService.push(settings.messenger.currentView.name, settings.messenger.currentView.params)
                }
                else {
                    // console.log('here3');
                    // push to homepage view on startup
                    // CoreService.push(Views.PAGE, {id: 'home'})
                }
            }
        },
        toggleFrameSize() {
            this.frameSize = this.frameSize === MessengerFrameSize.NORMAL ? MessengerFrameSize.EXPANDED : MessengerFrameSize.NORMAL;
            ParentService.toggleFrameSize();
        }
    },
});
